const TimePeriodSelector = ({
  selectedUnit,
  selectedOption,
  setSelectedOption,
  lastValue,
  setLastValue,
  nextValue,
  setNextValue,
  rightSideOptions,
  setSelectedUnit,
  visibleInAside3SideBar,
}) => {
  // console.log(selectedUnit);
  // console.log(selectedOption);

  const periodLabels = {
    Days: ["Yesterday", "Today", "Tomorrow", "Last", "Next"],
    Weeks: ["Last Week", "This Week", "Next Week", "Last", "Next"],
    Months: ["Last Month", "This Month", "Next Month", "Last", "Next"],
    Quarters: ["Last Quarter", "This Quarter", "Next Quarter", "Last", "Next"],
    Years: ["Last Year", "This Year", "Next Year", "Last", "Next"],
  };

  const renderInputOrStatic = (type, value, setValue) =>
    selectedOption === type ? (
      <input
        type="number"
        min="1"
        className="border rounded px-1 w-[45px] h-[20px]"
        value={value}
        onChange={(e) => setValue(e.target.value)}
      />
    ) : (
      <input
        type="number"
        min="1"
        className="border rounded px-1 w-[45px] h-[20px]"
        value={5}
        onChange={(e) => setValue(e.target.value)}
      />
    );

  return (
    <section className="w-full flex flex-col items-center justify-start h-[70%] p-1 gap-2">
      <div className="flex w-full items-center justify-center h-[20%]">
        {rightSideOptions.map((option) => (
          <button
            key={option.value}
            className={`text-center px-1 border-[1px] border-gray-200 ${
              selectedUnit === option.value ? "bg-blue-950 text-white" : ""
            } ${
              visibleInAside3SideBar
                ? "w-[60px] h-[25px] text-[12px]"
                : "w-[86px] h-[30px]"
            }`}
            onClick={() => setSelectedUnit(option.value)}
          >
            {option.value}
          </button>
        ))}
      </div>

      <div
        className={`w-full flex flex-wrap items-start justify-start gap-x-4 h-[80%] ${
          visibleInAside3SideBar ? "gap-y-[1rem]" : "gap-y-[2.5rem]"
        }`}
      >
        {periodLabels[selectedUnit].map((label, index) => (
          <label
            key={index}
            className={`flex items-center gap-1 justify-start px-1 cursor-pointer  ${
              visibleInAside3SideBar ? "w-[44%] text-[12px]" : "w-[35%]"
            }`}
          >
            <input
              type="radio"
              value={index}
              checked={selectedOption === index}
              onClick={() => setSelectedOption(index)}
            />
            {index === 3 || index === 4 ? (
              <>
                {label}
                {renderInputOrStatic(
                  index,
                  index === 3 ? lastValue : nextValue,
                  index === 3 ? setLastValue : setNextValue
                )}
                {selectedUnit}
              </>
            ) : (
              label
            )}
          </label>
        ))}
      </div>
    </section>
  );
};

export { TimePeriodSelector };
